import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { tap } from 'rxjs';
import { UnitCardService } from 'src/app/services/shared/unit-card.service';
import Swiper from 'swiper';

@Component({
  selector: 'terra-unit-cards-slider',
  templateUrl: './unit-cards-slider.component.html',
  styleUrls: ['./unit-cards-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class UnitCardsSliderComponent {
  @ViewChild('swiper') swiperRef: ElementRef | undefined;

  @Input() navigation = true;
  @Input() pagination = true;
  @Input() lazyLoad = true;
  
  @Output() onIndexChanged = new EventEmitter<number>();

  private readonly unitCardService = inject(UnitCardService);

  cardInd$ = this.unitCardService.unitBusinessCardInd$;
  viewSensitiveData$ = this.unitCardService.viewSensitiveData$;
  loadingSensitiveData$ = this.unitCardService.loadingSensitiveData$;
  unitBusinessVirtualDebitCard$ = this.unitCardService.unitBusinessCard$;
  unitBusinessVirtualDebitCards$ = this.unitCardService.unitBusinessCards$.pipe(
    tap(_ => this.goToSlide(0))
  );
  
  activeindexchange(event: CustomEvent<[swiper: Swiper]>) {
    const index = event?.detail[0]?.activeIndex;
    if (Number.isInteger(index)) {
      this.unitCardService.resetViewSensitiveData();
      this.unitCardService.updateUnitBusinessCardIndex(index);
    }
  }

  goToSlide(i: number) {
    const swiper: Swiper = this.swiperRef?.nativeElement?.swiper;
    swiper?.slideTo(i);
  }
}
